'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/min.js
// module id = 5631
// module chunks = 0